import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as createDemandActions from './actions';

export function* createBulkDemandPTL(payload) {
  const request = api.createBulkDemandPTLRequest.bind(null, payload);
  yield fetchEntity(request, createDemandActions.createBulkDemandPTL, payload);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/


export function* watchCreateBulkDemandPTLSaga() {
  while (true) {
    const { payload } = yield take(createDemandActions.CREATE_BULK_DEMAND_PTL[REQUEST]);
    yield fork(createBulkDemandPTL, payload);
  }
}
